import Vue from "vue";
import vuex from "vuex";
import pathify from "./pathify";
import { make } from "vuex-pathify";
import createPersistedState from "vuex-persistedstate";

Vue.use(vuex);
const state = {
  lang: "la",
  lotteryid: null,
  user: null,
  lottery: null,
  lotterytotalamount: null,
  round: null,
  rounds: null,
  israndombill: null,
  randombilldigit: null,
  randombillamount: null,
  randomcount: null,
  lotteryticket: null,
  paymentway: null,
  machineid: null,
  device: null,
  otpsignature: null,
  publicKey: null,
  privateKey: null,
  isshowpopup: null,
  predigits: null,
  loading: null,
  location: null,
  selectedproducts: [],
  favoritedigits: [],
  salehistory_url: null,
  draw_history_rounds: null,
  my_referrals: [],
  feeds_items: [],
  statement_point: null,
  appversion: null,
};
const mutations = {
  ...make.mutations(state),
  SET_USER(state, user) {
    if (user) {
      // Normalize userCategoryId
      if (user.usercategoryid !== undefined && user.usercategoryid !== null) {
        user.userCategoryId = Number(user.usercategoryid);
      } else if (
        user.userCategoryId !== undefined &&
        user.userCategoryId !== null
      ) {
        user.usercategoryid = Number(user.userCategoryId);
      }

      // Normalize userfullname
      if (user.userfullname !== undefined && user.userfullname !== null) {
        user.userFullName = user.userfullname;
      } else if (
        user.userFullName !== undefined &&
        user.userFullName !== null
      ) {
        user.userfullname = user.userFullName;
      }

      // Normalize username
      if (user.username !== undefined && user.username !== null) {
        user.userName = user.username;
      } else if (user.userName !== undefined && user.userName !== null) {
        user.username = user.userName;
      }

      // Normalize userid
      if (user.userid !== undefined && user.userid !== null) {
        user.userId = Number(user.userid);
      } else if (user.userId !== undefined && user.userId !== null) {
        user.userid = Number(user.userId);
      }

      // Normalize access_token
      if (user.access_token !== undefined && user.access_token !== null) {
        user.accessToken = user.access_token;
      } else if (user.accessToken !== undefined && user.accessToken !== null) {
        user.access_token = user.accessToken;
      }

      // Normalize refresh_token
      if (user.refresh_token !== undefined && user.refresh_token !== null) {
        user.refreshToken = user.refresh_token;
      } else if (
        user.refreshToken !== undefined &&
        user.refreshToken !== null
      ) {
        user.refresh_token = user.refreshToken;
      }

      // Normalize salehistory_url
      if (user.salehistory_url !== undefined && user.salehistory_url !== null) {
        state.salehistory_url = user.salehistory_url;
      } else if (
        user.salehistoryUrl !== undefined &&
        user.salehistoryUrl !== null
      ) {
        state.salehistory_url = user.salehistoryUrl;
      }

      // Normalize refreshExpiredDate
      const refExpDate =
        user.refreshExpiredDate ||
        user.refreshexpireddate ||
        user.refresh_expired_date ||
        user.refreshExpireDate;
      if (refExpDate !== undefined && refExpDate !== null) {
        user.refreshExpiredDate = refExpDate;
        user.refreshexpireddate = refExpDate;
        user.refresh_expired_date = refExpDate;
      }

      // Normalize expiredDate
      const expDate =
        user.expiredDate ||
        user.expireddate ||
        user.expired_date ||
        user.expireDate;
      if (expDate !== undefined && expDate !== null) {
        user.expiredDate = expDate;
        user.expireddate = expDate;
        user.expired_date = expDate;
      }
    } else {
      state.salehistory_url = null;
    }
    state.user = user;
  },
};
const store = new vuex.Store({
  state,
  mutations,
  plugins: [
    pathify.plugin,
    createPersistedState({
      key: "akatsuperwin",
      storage: window.localStorage,
    }),
  ],
});

global.store = store;
export default store;
